import { tickerItems } from '@/mocks/home';

export default function LiveTicker() {
  const doubled = [...tickerItems, ...tickerItems];

  return (
    <section className="border-b border-background-200/70 bg-foreground-950 py-3.5">
      <div className="td-marquee-wrap relative flex w-full overflow-hidden">
        <div className="td-marquee-track flex w-max items-center gap-8">
          {doubled.map((item, index) => (
            <span
              key={`${item}-${index}`}
              className="flex shrink-0 items-center gap-2 whitespace-nowrap text-xs text-background-100/85 md:text-sm"
            >
              <i className="ri-broadcast-line text-primary-400" />
              {item}
              <span className="text-background-100/25">/</span>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}